import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { PhotoProvider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { useSidebar } from '../context/SidebarContext';

const Layouts = ({ children, title, compFilter, openModal, dateFilter }) => {
  const { sidebarOpen, setSidebarOpen } = useSidebar();

  return (
    <div className="flex h-screen overflow-hidden">
      {/* <Navbar /> */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden bg-slate-100 dark:bg-slate-900 transition-colors duration-300">
        <Header
          openModal={openModal}
          compFilter={compFilter}
          title={title}
          dateFilter={dateFilter}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
        <main className="w-full flex-1 min-w-0">
          <PhotoProvider>
            <div className="min-h-[calc(100vh-140px)] flex flex-col relative">{children}</div>
          </PhotoProvider>
        </main>
      </div>
    </div>
  );
};

export default Layouts;
